import { UsecaseValidationMessage } from "../UsecaseValidationMessage";
import { TaxWithholdingKind, TaxWithholdingUsecase, UserDefinedRow } from "../../model";
import { BaseUsecaseLogic } from "../BaseUsecaseLogic";
import { DatelyObject, Numeric } from "../../util";
import { RowUsecaseCalcData } from "../RowUsecaseCalcData";

/** Client-side logic for TaxWithholding  */
export class TaxWithholdingUsecaseLogic extends BaseUsecaseLogic {

  /**
   * Updates the usecase values based on user input without going to the server.
   * @param row Row to update.
   * @param _date The reference date for which the logic is done.
   * Typically the salary date of a calculation and the typically, the information needed is just the year for which the yearly changing numbers are fetched, but may later have more extended features.
   * @param calcData The calculation related data that is required by the more complex calculations:
   * This data is available only after first round-trip to the server (results object exists) and not all user interfaces may provide this.
   */
  public updateUsecase(row: UserDefinedRow, _date: DatelyObject, calcData: RowUsecaseCalcData): void {
    const data: TaxWithholdingUsecase = row.data ?? {};
    data.kind = (data.kind || TaxWithholdingKind.Percentage);

    if (data.kind === TaxWithholdingKind.Undefined) {
      data.kind = TaxWithholdingKind.Percentage;
    }

    switch (data.kind) {
      case TaxWithholdingKind.FixedValue:
        row.price = data.taxValue;
        row.count = 1;
        break;
      case TaxWithholdingKind.Percentage:
        row.price = calcData.totalTaxable;
        row.count = ( data.taxValue >= 0 && data.taxValue <= 1 ) ? data.taxValue : 0;
        break;
    }
  }

  /** Gets validation message*/
  protected getUcValidation?(row: UserDefinedRow): UsecaseValidationMessage {
    const data: TaxWithholdingUsecase = row.data || {};
    let msg = "-";
    switch (data.kind) {
      case TaxWithholdingKind.Percentage:
        msg = `${Numeric.formatPercent(100.0 * row.data.taxValue, 1)}`;
        break;
      case TaxWithholdingKind.FixedValue:
        msg = `${Numeric.formatPrice(row.data.taxValue)}`;
        break;
    }
    return {
      msg,
      type: "default",
    };
  }
}